<template>
    <span>
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="open" color="primary" icon v-bind="attrs" v-on="on">
                    <v-icon >mdi-table-cog</v-icon>
                </v-btn>
            </template>
            <span>Selector de columnas</span>
        </v-tooltip>
        
        <draggable-show-hide-dialog
            v-model="dialog"
            :title="title"
            :show_columns="showHeaders"
            :hide_columns="hiddenHeaders"
            :key="dialog"
            @update="updateColumns"
            @cancel="dialog=false"
        >
            <template v-slot:top_actions>
                <slot name="actions"></slot>
            </template>
        </draggable-show-hide-dialog>
    </span>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import DraggableShowHideDialog from './DraggableShowHideDialog.vue';

export default {
    name: 'ShowHideColumnsDialog',
    props: {
        title: {
            type: String,
            default: 'Selector de columnas'
        },
        read_only:{
            type:Boolean,
            default:false,
        },
        showHideDialog:{
            type: Boolean,
            required: false, 
            default: null,
        },
    },
    data() {
        return {
            dialog: this.showHideDialog || false,
            show: [],
            hide: [],
        }
    },
    components: {
        DraggableShowHideDialog,
    },
    computed: {
        ...mapFields('documents', ['documentListHeaders', 'documentListHiddenHeaders','documentListHeadersReadOnly','documentListHiddenHeadersReadOnly']),
        showHeaders(){
            if(this.read_only){
                return this.documentListHeadersReadOnly
            }
            else{ 
                return this.documentListHeaders
            }
        },
        hiddenHeaders(){
            if(this.read_only){
                return this.documentListHiddenHeadersReadOnly
            }
            else{ 
                return this.documentListHiddenHeaders
            }
        },

    },
    methods:{
        ...mapActions({
            getHeader: "documents/getHeader",
            setHeader: "documents/setHeader",
            setHeaderReadOnly: "documents/setHeaderReadOnly",
        }),
        open() {
            this.dialog = !this.dialog;
        },
        updateColumns(data) {
            if(!this.read_only){
                this.documentListHeaders = data['show']
                this.documentListHiddenHeaders = data['hide']
                this.setHeader().then(() => {
                    this.dialog = false;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }
            else{
                this.documentListHeadersReadOnly = data['show']
                this.documentListHiddenHeadersReadOnly = data['hide']
                this.setHeaderReadOnly().then(() => {
                    this.dialog = false;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }

        },
        
    },
    mounted(){
        this.getHeader()

    },
}
</script>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: #663399;
    }
    .primary-border {
        border-color: #663399 !important;
    }
    .draggable-item {
        border-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .text-color {
        color: #663399;
    }
</style>
